import AuthContext, { CurrentUserModel, Role } from './auth-context';
import { decode } from './jwt-decoder';
import { useNavigate, useSearchParams } from 'react-router';

const tokenKey = 'AUTH_TOKEN';

let storedToken = JSON.parse(window.sessionStorage.getItem(tokenKey));

const updateStoredToken = (token: string) => {
    storedToken = token;
    window.sessionStorage.setItem(tokenKey, JSON.stringify(token));
};

export const getToken = () => storedToken;

const getUser = (token: string): CurrentUserModel => {
    if (token == null) {
        return null;
    }
    const { userId, name, firstName, lastName, admin, owner, accountManager, accountId, language } =
        decode(token) as any;
    const user: CurrentUserModel = {
        id: userId,
        firstName,
        lastName,
        name,
        accountId,
        role: getRole(admin, owner, accountManager),
        language
    };
    return user;
};

const getRole = (admin: boolean, owner: boolean, accountManager: boolean): Role => {
    let role = Role.Advisor;
    if (owner) {
        // tslint:disable-next-line:no-bitwise
        role |= Role.Owner;
    }
    if (admin) {
        // tslint:disable-next-line:no-bitwise
        role |= Role.Admin;
    }
    if (accountManager) {
        // tslint:disable-next-line:no-bitwise
        role |= Role.AccountManager;
    }
    return role;
};

const withToken = Component => props => <Component {...props} setToken={updateStoredToken} />;

const Authentication = ({ children, setToken }) => {
    const [queryParams] = useSearchParams();
    const queryToken = queryParams.get('token');
    // FIXME: this should be a prop, but causes a timing issue
    const token = queryToken || storedToken;

    // FIXME
    if (queryToken) {
        updateStoredToken(queryToken);
    }

    const navigate = useNavigate();

    const user = getUser(token);

    const logout = () => {
        setToken(null);
        navigate('/auth/login');
    };

    return (
        <AuthContext.Provider
            value={{
                loggedIn: !!token,
                user,
                login: setToken,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default withToken(Authentication);
